module.exports = __webpack_public_path__ + "assets/img/body_bg.220a6614.jpg";